// @flow
import React from 'react'

import CartWithItems from './CartWithItems'
import CartNoItems from './CartNoItems'

type Props = {
  color: string,
  isCartEmpty: boolean,
  navigateTo: Function,
  total: number,
  width: string
}

const Cart = (props: Props) => {
  return !props.isCartEmpty ? (
    <CartWithItems
      navigateTo={props.navigateTo}
      total={props.total}
      viewport={props.width}
      color={props.color}
    />
  ) : (
    <CartNoItems color={props.color} viewport={props.width} />
  )
}

export default Cart
